import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import NotFoundAnimation from "./404 error.lottie";
export default function NotFound() {
    return (
        <div className='min-vh-100 d-flex justify-content-center align-items-center'>
            <DotLottieReact
                src={NotFoundAnimation}
                loop
                autoplay
            />
        </div>
    )
}
